


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { Feature, FeatureCollection } from "geojson";

import MilSymbol from "@/components/MilSymbol";

const DEFAULT_SIDC = "10030100001101000000";

@Component({
  components: { MilSymbol }
})
export default class MarkerList extends Vue {
  @Prop({ required: true, type: Object }) markers!: FeatureCollection;
  DEFAULT_SIDC = DEFAULT_SIDC;

  get features() {
    return this.markers.features;
  }

  onMarkerClick(feature: Feature) {
    this.$emit('markerSelect', feature);
  }
}

